import validate from "/var/www/scan.ova-restaurant.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import restaurant_45global from "/var/www/scan.ova-restaurant.com/middleware/restaurant.global.ts";
import wasabi_45locale_45global from "/var/www/scan.ova-restaurant.com/middleware/wasabi-locale.global.ts";
import manifest_45route_45rule from "/var/www/scan.ova-restaurant.com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  restaurant_45global,
  wasabi_45locale_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}